module.exports = __webpack_public_path__ + "img/SaveOutlined.19304edf.svg";